import React from 'react';
import { Box, Divider } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const DividerWithText = ({ className, text }) => {
  const styles = useStyles();

  return (
    <Box
      className={cx(styles.root, className)}
      textAlign="center"
    >
      <Divider className={styles.divider} />
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.regular14}
        className={styles.text}
      >
        {text}
      </CustomTypography>
    </Box>
  );
};

DividerWithText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};
DividerWithText.defaultProps = {
  className: '',
  text: '',
};
